export const DEFAULT_BUSINESS_PROFILE = 'retail';

export const BUSINESS_PROFILES = Object.freeze([
  Object.freeze({
    code: 'retail',
    label: 'Varejo',
    signupLabel: 'Varejo — lojas e comércio em geral',
    modeLabel: 'Modo Varejo',
    description: 'Vendas por unidade, estoque, caixa e gestão comercial.',
    weightedSales: false
  }),
  Object.freeze({
    code: 'supermarket',
    label: 'Supermercado e mercearia',
    signupLabel: 'Supermercado, mercado ou mercearia',
    modeLabel: 'Modo Supermercado',
    description: 'PDV preparado para produtos por unidade ou peso e uso de balança.',
    weightedSales: true
  }),
  Object.freeze({
    code: 'food_service',
    label: 'Alimentação',
    signupLabel: 'Alimentação — bar, restaurante, hamburgueria, pizzaria ou lanchonete',
    modeLabel: 'Modo Alimentação',
    description: 'Operação de alimentação com catálogo, produção e venda por unidade ou peso.',
    weightedSales: true
  }),
  Object.freeze({
    code: 'services',
    label: 'Serviços',
    signupLabel: 'Prestação de serviços',
    modeLabel: 'Modo Serviços',
    description: 'Clientes, serviços, financeiro e gestão da operação.',
    weightedSales: false
  }),
  Object.freeze({
    code: 'other',
    label: 'Outro segmento',
    signupLabel: 'Outro tipo de negócio',
    modeLabel: 'Modo Geral',
    description: 'Configuração geral para operações que não se encaixam nos demais segmentos.',
    weightedSales: false
  })
]);

export const ONBOARDING_BUSINESS_PROFILE_OPTIONS = Object.freeze([
  Object.freeze({
    value: 'fashion',
    canonicalCode: 'retail',
    label: 'Moda e acessórios',
    icon: 'fa-tshirt',
    description: 'Lojas de roupas, calçados, bolsas, joias e acessórios, sem mesas ou comandas.'
  }),
  Object.freeze({
    value: 'retail',
    canonicalCode: 'retail',
    label: 'Varejo em geral',
    icon: 'fa-store',
    description: 'Comércio com vendas, estoque, caixa, financeiro, fiscal e canais de ecommerce.'
  }),
  Object.freeze({
    value: 'supermarket',
    canonicalCode: 'supermarket',
    label: 'Supermercado e mercearia',
    icon: 'fa-shopping-basket',
    description: 'Operação de varejo com produtos por unidade ou peso e suporte a balança.'
  }),
  Object.freeze({
    value: 'food_service',
    canonicalCode: 'food_service',
    label: 'Alimentação',
    icon: 'fa-utensils',
    description: 'Bares, restaurantes, lanchonetes e similares, com mesas, comandas e delivery.'
  }),
  Object.freeze({
    value: 'services',
    canonicalCode: 'services',
    label: 'Prestação de serviços',
    icon: 'fa-briefcase',
    description: 'Operação focada em clientes, serviços, equipe, financeiro, relatórios e fiscal.'
  }),
  Object.freeze({
    value: 'other',
    canonicalCode: 'other',
    label: 'Outro segmento',
    icon: 'fa-shapes',
    description: 'Configuração geral para negócios que não se encaixam nas opções anteriores.'
  })
]);

export const BUSINESS_PROFILE_ALIASES = Object.freeze({
  fashion: 'retail',
  moda: 'retail',
  moda_e_acessorios: 'retail',
  bar: 'food_service',
  restaurante: 'food_service',
  hamburgueria: 'food_service',
  pizzaria: 'food_service',
  lanchonete: 'food_service'
});

const BUSINESS_PROFILE_BY_CODE = Object.freeze(
  Object.fromEntries(BUSINESS_PROFILES.map((profile) => [profile.code, profile]))
);

function profileToken(value) {
  return String(value == null ? '' : value)
    .normalize('NFKC')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

export function normalizeBusinessProfile(value, fallback = DEFAULT_BUSINESS_PROFILE) {
  const token = profileToken(value);
  if (!token) return fallback;
  const canonical = BUSINESS_PROFILE_ALIASES[token] || token;
  return BUSINESS_PROFILE_BY_CODE[canonical] ? canonical : null;
}

export function getBusinessProfile(value, fallback = DEFAULT_BUSINESS_PROFILE) {
  const code = normalizeBusinessProfile(value, fallback);
  return (code && BUSINESS_PROFILE_BY_CODE[code])
    || BUSINESS_PROFILE_BY_CODE[DEFAULT_BUSINESS_PROFILE];
}

export function businessProfileFromUser(user, actor = null) {
  return getBusinessProfile(
    actor?.tenant?.businessProfile
      ?? user?.tenant?.businessProfile
      ?? user?.businessProfile
      ?? user?.business_profile
      ?? user?.tenant_business_profile
  );
}
